export default __webpack_public_path__ + "static/media/EvoESG-white.6e8c2a89.png";